module.exports = "https://cdn-skillquest.mathletics.com/app/174/assets/images/11d32419f8bc0e3125928a6587f5d1fa.svg";